import React from 'react';

function Alert({ variant = 'info', icon: Icon, title, children, className = '', ...rest }) {
  return (
    <div className={['alert', `alert-${variant}`, className].filter(Boolean).join(' ')} role="status" {...rest}>
      {Icon && <Icon size={18} style={{ flexShrink: 0, marginTop: 1 }} />}
      <div>
        {title && <div className="alert-title">{title}</div>}
        {children}
      </div>
    </div>
  );
}

export default Alert;
